import React, { useState } from "react";
import { createPortal } from 'react-dom';
import { useHistory } from 'react-router-dom';
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  inviteUserAsProviderResource
} from "../../../../services/staffingService";

const providerResourceSchema = yup.object({
  providerResourceEmail: yup
    .string()
    .required("Email is required for Provider Resource")
    .email("Must be a valid email address"),
});



const OfficerInvite = ({ open , handleClose , providerCompanyId }) => {
  const history = useHistory();

  const [resourceResponse, setResourceResponse] = useState("");
  const [resourceError, setResourceError] = useState(false);


  const {
    register: registerResource,
    handleSubmit: handleSubmitResource,
    formState: { errors: errorsResource },
    reset: resetResource,
  } = useForm({
    resolver: yupResolver(providerResourceSchema),
  });

  const onSubmitProviderResource = async (data) => {
    try {
      const resp = await inviteUserAsProviderResource(
        providerCompanyId,
        data.providerResourceEmail
      );
      const { providerResourceId, message } = resp.data;
      setResourceResponse(message || 'Officer invited successfully.');
      setResourceError(false);
      // Redirect to the officer's profile so the manager can add location immediately
      if (providerResourceId) {
        setTimeout(() => {
          handleClose();
          history.push(`/provider-company/${providerCompanyId}/orm/${providerResourceId}`);
        }, 800);
      }
    } catch (error) {
      setResourceResponse(error.response?.data?.message || error.response?.data || "Failed to send invitation");
      setResourceError(true);
    }
  };

  return (
    <>
      {open && createPortal(
        <div className="fixed inset-0 overflow-hidden" style={{ zIndex: 9998 }}>
          {/* Background Overlay */}
          <div 
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={handleClose}
            style={{ zIndex: 9998 }}
          />
          
          {/* Modal Panel */}
          <div className="absolute inset-0 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md relative" style={{ fontFamily: 'Inter' }}>
              {/* Close Button */}
              <button
                onClick={handleClose}
                className="absolute top-4 right-4 flex items-center justify-center w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors z-10"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Header */}
              <div className="px-6 pt-6 pb-4 border-b border-[#E4E4E4]">
                <h2 className="text-xl font-bold text-black leading-6 m-0">Add Officer</h2>
                <p className="text-sm text-gray-600 mt-1">Onboard new officers</p>
              </div>

              {/* Body */}
              <div className="px-6 py-6">
                <form
                  onSubmit={handleSubmitResource(onSubmitProviderResource)}
                  className="space-y-4"
                >
                  <div className="flex items-center gap-2">
                    <input
                      type="email"
                      className="form-input flex-1"
                      {...registerResource("providerResourceEmail")}
                      placeholder="Add security personnel email"
                    />
                    <button
                      type="submit"
                      className="w-10 h-10 bg-[#404880] text-white font-bold rounded-lg hover:bg-[#363e70] transition-colors flex items-center justify-center"
                    >
                      +
                    </button>
                  </div>
                  
                  {resourceResponse && (
                    <div className={`text-sm p-3 rounded-lg ${
                      resourceError 
                        ? "bg-red-50 text-red-700 border border-red-200" 
                        : "bg-green-50 text-green-700 border border-green-200"
                    }`}>
                      {resourceResponse}
                    </div>
                  )}
                  
                  {errorsResource.providerResourceEmail && (
                    <div className="text-sm text-red-600 bg-red-50 p-3 rounded-lg border border-red-200">
                      {errorsResource.providerResourceEmail.message}
                    </div>
                  )}
                </form>
              </div>

              {/* Footer */}
              <div className="px-6 pb-6">
                <div className="flex justify-end gap-3">
                  <button
                    onClick={handleClose}
                    className="px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}

export default OfficerInvite;